module.exports = __webpack_public_path__ + "static/img/LXWM-34.7d51a0a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/images/base/LXWM-34.jpeg
// module id = /4LT
// module chunks = 1